import { LanguageType } from '@webclient/shared-types/translation';

import axios from 'axios';

const translations = {
  getOne: (lang: LanguageType) =>
    axios.get(`${import.meta.env.VITE_APP_TOLGEE_S3_URI}/i18n/${lang}.json`),
};

export default translations;
